import { createFileRoute } from '@tanstack/react-router'
import { useReport } from '@/hooks/use-report'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { ReportComponent } from './-components/report/report'

export const Route = createFileRoute('/_app/orgs/$orgId/groups/$groupId/report')({
  component: RouteComponent,
  pendingComponent: NestedReportPending,
  // Painted on the click frame, or the NAV STACK cannot push while the loaders run — see jobs._list.$jobId.report.
})

function RouteComponent() {
  const context = Route.useRouteContext()
  const { report, isFetching } = useReport(context.reportQueryOptions)
  return <ReportComponent report={report} isFetching={isFetching} />
}
